import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useMyDataQuery } from '@/generated/graphql';
import { useHasFeature } from '@/lib/useHasFeature';
import { QUOTE_CAROUSEL_FEATURE } from '@/lib/quoteCarousel/quoteCarouselFeature';

/** Gates `/clips/:clipId/carousel` on the quote_carousel plan/subscription
 *  feature. Mirrors `SocialPublishingRoute`: wait for `myData` to load
 *  before deciding, so a flagged user is never bounced during loading. */
const QuoteCarouselFeatureRoute = ({ children }: { children: ReactNode }) => {
  const { loading } = useMyDataQuery();
  const hasQuoteCarousel = useHasFeature(QUOTE_CAROUSEL_FEATURE);

  if (loading) return null;

  if (!hasQuoteCarousel) {
    return <Navigate to="/clips" replace />;
  }

  return <>{children}</>;
};

export default QuoteCarouselFeatureRoute;
